import { ArgsProps } from 'antd/es/notification'
import { useDispatch } from 'react-redux'
import {
  NotificationType,
  showNotification as showNotificationRaw,
} from 'src/features/notificationService/slice'

/**
 * 通知を表示するためのカスタムフック
 *
 * なおhooksはsagaから直接呼び出すことはできないので、
 * sagaから通知を利用したい場合は直接アクションをputすること
 */
export const useNotificationService = () => {
  const dispatch = useDispatch()

  const showNotification = (
    message: string,
    option?: {
      duration?: number
      description?: ArgsProps['description']
      notificationType?: NotificationType
    },
  ) => {
    const { duration, description, notificationType } = option || {}
    dispatch(
      showNotificationRaw({ duration, message, description, notificationType }),
    )
  }

  return { showNotification }
}
